import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import CompanyLogoSet from 'src/app/molecules/CompanyLogoSet/CompanyLogoSet';

const SocialProofTrusted = (): JSX.Element => (
  <Grid
    padding={['spacing-none', 'spacing-4xl']}
    paddingSm='spacing-none'
  >
    <Stack>
      <CompanyLogoSet />
    </Stack>
  </Grid>
);

export default SocialProofTrusted;
